// utils/autoPopulatePepSanReasons.js

import dayjs from "dayjs";

const normDob = (v) => {
  if (!v) return null;
  const d = dayjs(v);
  return d.isValid() ? d.format("YYYY-MM-DD") : null;
};

const buildRefsFromMatches = (results = []) => {
  const counters = {};
  const cards = [];

  results.forEach((match) => {
    const types = Array.isArray(match?.matchingCriteria)
      ? [
          ...new Set(
            match.matchingCriteria.map((c) =>
              String(c?.searchType || "").toUpperCase(),
            ),
          ),
        ]
      : [];

    types.forEach((t) => {
      counters[t] = (counters[t] || 0) + 1;
      cards.push({
        type: t,
        ref: `${t}${counters[t]}`,
        match,
      });
    });
  });

  return cards;
};

export function autoPopulatePepSanReasons({
  results, // searchResults[0].results
  applicantDob, // applicant DOB string
}) {
  // console.log("Auto-populating PEP/SAN reasons with results and applicantDob", results, (applicantDob));
  // console.log("Auto-populating PEP/SAN reasons with applicantDob", applicantDob);
  const appDob = normDob(applicantDob);
  if (!Array.isArray(results) || !results.length) return {};

  const cards = buildRefsFromMatches(results);

  const reasonMap = {};

  cards.forEach((c) => {
    const type = String(c.type || "").toUpperCase();
    const ref = c.ref;

    // RCA -> Always refer
    if (type.startsWith("RCA")) {
      // console.log(
      //   `Auto-populating reason for ${ref} as RCA match -> Refer to Compliance`,
      // );
      // reasonMap[ref] = ["Refer to Compliance"];
      return;
    }

    // Only PEP / SAN from here
    const recordDob = normDob(c?.match?.record?.dateOfBirth);

    // console.log(`Auto-populating reason for ${ref} with applicantDob ${appDob} and recordDob ${recordDob}`, ); // DOB mismatch -> Not your client due to Date of Birth

    if (appDob && recordDob && appDob !== recordDob) {
      reasonMap[ref] = ["Not your client due to Date of Birth"];
    }
  });

  return reasonMap;
}
